/**
 * RESPONSIBILITY: draw one stack of an event's bands, in order.
 *
 * A page is a stack of sections and a section knows its own theme, so this hands each one
 * to the band registered for it and does not otherwise know what any of them are. That is
 * what lets a thirteenth theme be a file and a key rather than an edit here.
 *
 * Used for both stacks. Where the page has a sidebar the second one is drawn in it, and
 * where it has not the two are drawn one after the other — either way this is the same
 * component, because "a stack of bands" does not change with which column it is in.
 *
 * A band switched off is not drawn, for anybody — the same rule MinistryBody follows, and
 * for the same reason: the switch is a row of the list this event's pencil opens.
 */
import { idOf } from '@framework/core';
import type { EventRow, EventSectionRow } from '@app/sections';
import { bandFor } from './themes';
import { isShown } from '../commons/shown';

export interface EventStackProps {
  sections: readonly EventSectionRow[] | undefined;
  event: EventRow;
  all: readonly EventRow[];
}

export function EventStack({ sections, event, all }: EventStackProps) {
  return (
    <>
      {(sections ?? []).filter(isShown).map((s) => {
        const Draw = bandFor(s.theme);
        return Draw ? <Draw key={idOf(s)} s={s} event={event} all={all} /> : null;
      })}
    </>
  );
}
